import getData from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import { ProTeams } from "@/game-lol/models/lol-pro-teams.mjs";

export function getProTeams(options = {}) {
  return getData(
    `${appURLs.CDN_PLAIN}/league/pro_teams.json`,
    ProTeams,
    ["lol", "proBuildTeams"],
    options,
  );
}
